import { createClient } from '@supabase/supabase-js'

let client: ReturnType<typeof createClient> | null = null

export function getSupabaseClient() {
  if (client) {
    return client
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  console.log('[Vue] Supabase 配置检查:')
  console.log('[Vue] VITE_SUPABASE_URL:', supabaseUrl)
  console.log('[Vue] VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '已设置' : '未设置')

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('[Vue] Supabase 环境变量未配置')
    console.error('[Vue] VITE_SUPABASE_URL:', supabaseUrl)
    console.error('[Vue] VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '已设置' : '未设置')

    // 返回一个模拟客户端以避免应用崩溃
    return createClient(
      supabaseUrl || 'https://placeholder.supabase.co',
      supabaseAnonKey || 'placeholder-key'
    )
  }

  // 验证 URL 格式（支持阿里云 Supabase 域名）
  if (!supabaseUrl.startsWith('https://') || 
      (!supabaseUrl.includes('.supabase.co') && !supabaseUrl.includes('.supabase.opentrust.net'))) {
    console.error('[Vue] Supabase URL 格式不正确:', supabaseUrl)
  }

  client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  })

  return client
}
